/*
 * @Description: 知识库api
 * @Author: ljrong
 * @Date: 2024-03-16 14:38:36
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2024-08-27 20:53:46
 */
import { get, post } from '@/utils/request'

import type { EnterpriseListModel } from '@/types/enterprise'
import type {
    LibStatusItem,
    GenericKnowledgeBaseItem,
    KnowlegeSelectorParams,
    KnowlegeSelectorModel,
    LibPathItem
} from '@/types/knowledge/lib'


/**
 * 空间下知识库概要 - 列出空间下各个知识库有多少个文件
 */
export function getLibStatus(data: { enterpriseId: number | null }) {
    return post<LibStatusItem[]>({
        url: '/assistant/lib/stats',
        data
    })
}

/**
 * 基本知识库列表  - 获取通用知识库列表
 */
export function getGenericKnowledgeBase() {
    return post<GenericKnowledgeBaseItem[]>({
        url: '/assistant/lib/listGenericKnowledgeBase'
    })
}

/**
 * 知识库权限 - 就是当前用户在当前空间下有哪些知识库的权限 于 src/api 下的 getWorkspaces 方法一致
 */
export function getWorkspaces() {
    return post<EnterpriseListModel>({
        url: '/assistant/enterprise/getWorkspace',
    })
}


/**
 * 树形列表 获取知识库结构 工作空间 -> 知识库 -> 文件夹 -> 文件
 */
export function getKnowlegeSelectorTree(data: KnowlegeSelectorParams) {
    return post<KnowlegeSelectorModel>({
        url: '/assistant/lib/getSelector',
        data
    })
}


/**
 * 根据知识库id 查找文件夹列表
 */
export function getFolderListByLibId(data: { libId: number }) {
    return get<{ dirId: number, dirName: string, fileCount: number }[]>({
        url: '/assistant/lib/dir/listDir',
        data
    })
}

/**
 * 根据知识库id获取path
 */
export function getLibPath(id: number | string) {
    return get<LibPathItem[]>({
        url: '/assistant/lib/paths/' + id,
    })
}

/**
 * 根据知识库文件夹id获取path
 */
export function getDirPath(id: number | string) {
    return get<LibPathItem[]>({
        url: '/assistant/lib/dir/paths/' + id,
    })
}

/**
 * 根据知识库文件id获取path
 */
export function getFilePath(id: number | string) {
    return get<LibPathItem[]>({
        url: '/assistant/lib/file/paths/' + id,
    })
}


/**
 * 根据知识库文件id获取path
 */
export function getActivityShare() {
    return get<boolean>({
        url: '/assistant/lib/activityShare'
    })
}


/**
 * 搜索推荐词
 */
export function getRecommendedWords() {
    return get<{
        records: string[]
    }>({
        url: '/assistant/lib/recommendedWords?pageSize=50&page=1'
    })
}

/**  */
/**
 * 共享文件到
 * @param data anon: 0：不匿名，1：匿名
 */
export function shareFileToDir(data: {
    dirId: number
    fileIds: number[]
    enterpriseId?: number
    knowledgeBaseId?: number
    anon: number
}) {
    return post<boolean>({
        url: '/assistant/lib/file/shareFile',
        data
    })
}



/**
 * 剩余可上传文件数量
 * @returns limit 剩余大小：文件为个数，大小单位为kb;type 剩余类型：0：文件个数 1：文件大小;allLimit 总限制大小：文件为个数，大小单位为b
 */
export function getLibFileRemain(knowledgeBaseId: string | number) {
    return get<{ allLimit: number; limit: number; type: number }>({
        url: `/assistant/lib/file/filesRemain?knowledgeBaseId=${knowledgeBaseId}`,
    })
}